import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Mitigate third-party script loading issues (like PayPal SDK partitioned cookie/iframe blocks)
// which bubble up to the global scope as 'Script error.' and trigger development/production overlays.
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    const msg = event.message || '';
    const file = event.filename || '';
    if (
        msg.includes('Script error.') ||
        msg.includes('paypal') ||
        msg.includes('Failed to fetch') ||
        msg.includes('fetch') ||
        file.includes('paypal') ||
        file.includes('paypal.com')
    ) {
      console.warn('[Security Bypass] Intercepted cross-origin third-party script error:', {
        message: msg,
        filename: file,
        error: event.error
      });
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason ? String(event.reason) : '';
    if (
        reason.includes('paypal') ||
        reason.includes('Script error.') ||
        reason.includes('paypal.secure.checkout') ||
        reason.includes('Failed to fetch') ||
        reason.includes('fetch')
    ) {
      console.warn('[Security Bypass] Intercepted cross-origin unhandled rejection:', event.reason);
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
}

createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
);

